import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@amzn/atoz-web/Button';
export var OpportunityDetailsModalButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-describedby": "OpportunityDetailsModalButton", "data-testid": "OpportunityDetailsModalButton", onClick: onClick }, t('shift_management_features_ShiftDetailsModalButtonView_buttonText')),
        React.createElement("span", { hidden: true, id: "OpportunityDetailsModalButton" }, t('shift_management_views_ShiftDetailsModalButtonView_buttonLabel'))));
};
